export default __webpack_public_path__ + "static/media/Rectangle 1055.6afc8a09.png";